import { stateOptions } from '../../../../shared/helper/states'
import AddressSummary from './AddressSummary'

export default {
  components: {
    AddressSummary,
  },

  // language=HTML (for PhpStorm)
  template: `
    <ui-form-partial label="Personal Information">
      <ui-form-item label="First Name">
        {{ model.applicant.firstName }}
      </ui-form-item>

      <ui-form-item label="Middle Name">
        {{ model.applicant.middleName }}
      </ui-form-item>

      <ui-form-item label="Last Name">
        {{ model.applicant.lastName }}
      </ui-form-item>

      <ui-form-item label="Birth Date">
        {{ model.applicant.dateOfBirth }}
      </ui-form-item>

      <ui-form-item label="Social Security Number">
        {{ model.applicant.ssn }}
      </ui-form-item>

      <br>
      <ui-form-item label="Drivers License Number">
        {{ model.applicant.driversLicense.number }}
      </ui-form-item>

      <ui-form-item label="Issuing State">
        {{ model.applicant.driversLicense.state }}
      </ui-form-item>

      <br>
      <ui-form-item label="Home Phone Number">
        {{ model.applicant.phone.home }}
      </ui-form-item>

      <ui-form-item label="Cell Phone Number">
        {{ model.applicant.phone.cell }}
      </ui-form-item>

      <ui-form-item label="Email">
        {{ model.applicant.email }}
      </ui-form-item>

      <br>
      <ui-form-item label="Service Address">
        <address-summary :address="model.applicant.serviceAddress" />
      </ui-form-item>

      <br>
      <ui-form-item label="My mailing address is different than my service address">
        {{ model.applicant.mailingAddress.isDifferentThanService ? 'Yes' : 'No' }}
      </ui-form-item>

      <template v-if="model.applicant.mailingAddress.isDifferentThanService">
        <ui-form-item label="Mailing Address">
          <address-summary :address="model.applicant.mailingAddress" />
        </ui-form-item>
      </template>

      <br>
      <p>
        <b>Your Employer</b>
      </p>
      <ui-form-item label="Name">
        {{ model.applicant.employer.name }}
      </ui-form-item>

      <ui-form-item label="Phone Number">
        {{ model.applicant.employer.phone }}
      </ui-form-item>
    </ui-form-partial>
  `,

  props: {
    model: Object,
  },

  computed: {
    stateOptions() {
      return stateOptions
    },
  },
}
